<template>
  <div>
    <div class="background">
      <el-form
        ref="form"
        :model="form"
        :inline="true"
      >
        <el-form-item label="发票代码：" prop="invoiceCode">
          <el-input v-model="form.invoiceCode"></el-input>
        </el-form-item>
        <el-form-item label="发票号码：" prop="invoiceNo">
          <el-input v-model="form.invoiceNo"></el-input>
        </el-form-item>
        <el-form-item label="核销状态：" prop="invoiceStatus">
          <el-select v-model="form.invoiceStatus">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in invoiceStatusOption" :key="item.label" :label="item.value" :value="item.label"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" size="mini" @click="getList">查询</el-button>
        <el-button size="mini" @click="resetForm">重置</el-button>
      </div>
    </div>

    <div class="background">
      <el-table
        :data="tableData"
        border
        style="width: 100%">
        <el-table-column
          prop="invoiceCode"
          align="center"
          label="发票代码">
        </el-table-column>
        <el-table-column
          prop="invoiceNo"
          align="center"
          label="发票号码">
        </el-table-column>
        <el-table-column
          prop="sellerName"
          align="center"
          label="销方名称">
        </el-table-column>
        <el-table-column
          prop="buyerName"
          align="center"
          label="购方名称">
        </el-table-column>
        <el-table-column
          prop="spuName"
          align="center"
          label="发票品类">
        </el-table-column>
        <el-table-column
          prop="amount"
          align="center"
          label="金额">
        </el-table-column>
        <el-table-column
          prop="taxAmount"
          align="center"
          label="税额">
        </el-table-column>
        <el-table-column
          prop="invoiceTotalPriceTax"
          align="center"
          label="税价合计">
        </el-table-column>
        <el-table-column
          prop="billingDate"
          align="center"
          label="发票申请时间">
        </el-table-column>
        <el-table-column
          prop="updateTime"
          align="center"
          label="发票核销时间">
        </el-table-column>
        <el-table-column
          prop="writeOffStatus"
          align="center"
          label="核销状态">
        </el-table-column>
        <el-table-column
          align="center"
          label="操作">
          <template slot-scope="scope">
            <el-button @click="handleWriteOff(scope.row)" type="text" size="small" v-if="scope.row.invoiceStatus === 10">核销发票</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="form.pageIndex"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="form.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 账单核销 -->
    <el-dialog
      title="账单信息填写"
      :visible.sync="dialogVisible"
      width="70%"
    >
      <div>发票可核销金额：{{ totalAmount }}</div>
      <el-form
        ref="form"
        style="margin-top: 20px;"
        :model="writeOffSearchForm"
        :inline="true"
      >
        <el-form-item label="日期：">
          <el-date-picker
            v-model="date"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="油品：" prop="oilSpu">
          <el-select v-model="writeOffSearchForm.oilSpu" disabled>
            <el-option v-for="item in spuTypeOptions" :key="item.label" :label="item.value" :value="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchBill">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="infoTableData"
        :row-key="row => row.id"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%">
        <el-table-column
          :reserve-selection="true"
          :selectable="selectable"
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="billDay"
          align="center"
          label="账单月份">
        </el-table-column>
        <el-table-column
          prop="gasName"
          align="center"
          label="油站">
        </el-table-column>
        <el-table-column
          prop="oilSpuName"
          align="center"
          label="油品">
        </el-table-column>
        <el-table-column
          prop="invoiceAmount"
          align="center"
          label="油站应开发票总金额(元)">
        </el-table-column>
        <el-table-column
          prop="signBodyName"
          align="center"
          label="签约主体">
        </el-table-column>
        <!-- <el-table-column
          prop="invoiceCode"
          align="center"
          label="油站收款账户名称">
        </el-table-column> -->
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleInfoSizeChange"
          @current-change="handleInfoCurrentChange"
          :current-page="writeOffSearchForm.pageIndex"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="writeOffSearchForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="infoTotal">
        </el-pagination>
      </div>
      <div slot="footer" style="text-align: center;">
        <el-button @click="hideDialog">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { getEnum, controlOverInvoices, queryInvoiceNew, batchVerificationBills } from '@/api/finance'

  export default {
    data () {
      return {
        form: {
          invoiceCode: '',
          invoiceNo: '',
          invoiceStatus: '',
          pageSize: 10,
          pageIndex: 1
        },
        invoiceStatusOption: [],
        tableData: [], // 发票管理列表
        dialogVisible: false,
        total: 0,
        date: [],
        writeOffSearchForm: {
          bindInvoice: true,
          oilSpu: '10001',
          startTime: '',
          endTime: '',
          pageSize: 10,
          pageIndex: 1
        },
        writeOffForm: { // 批量核销
          invoiceInfoDtos: [{
            invoiceNo: '',
            invoiceCode: '',
            spuName: '',
            spuId: ''
          }],
          billIds: [],
          verificationType: 2
        },
        spuTypeOptions: [],
        infoTotal: 0,
        infoTableData: [], // 账单列表
        selection: [],
        totalAmount: 0
      }
    },
    methods: {
      async initEnum () {
        const { code, result } = await getEnum()
        if (code !== 200) return
        this.invoiceStatusOption = result.invoiceStatusOption
        this.spuTypeOptions = result.spuTypeOption
      },
      async getList () {
        const { code, result, totalRow } = await controlOverInvoices(this.form)
        if (code !== 200) return
        this.tableData = result
        this.total = totalRow
      },
      handleSizeChange (val) {
        this.form.pageSize = val
        this.getList()
      },
      handleCurrentChange (val) {
        this.form.pageIndex = val
        this.getList()
      },
      // 点击核销发票
      handleWriteOff ({ invoiceCode, invoiceNo, spuName }) {
        this.dialogVisible = true
        this.writeOffForm.invoiceInfoDtos[0].invoiceCode = invoiceCode
        this.writeOffForm.invoiceInfoDtos[0].invoiceNo = invoiceNo
        this.writeOffSearchForm.oilSpu = this.spuTypeOptions.find(item => item.value === spuName)?.label
        this.getInfoData()
      },
      searchBill () {
        this.$refs.multipleTable.clearSelection()
        this.getInfoData()
      },
      // 查询账单数据
      async getInfoData () {
        this.writeOffSearchForm.startTime = this.date[0] || ''
        this.writeOffSearchForm.endTime = this.date[1] || ''
        const { code, result, totalRow } = await queryInvoiceNew(this.writeOffSearchForm)
        if (code !== 200) return
        this.infoTableData = result
        this.infoTotal = totalRow
      },
      // 提交账单核销
      async handleSubmit () {
        if (!this.selection.length) {
          this.$message.error('请选择账单')
          return
        }
        this.writeOffForm.billIds = this.selection.join(',')
        const { code } = await batchVerificationBills(this.writeOffForm)
        if (code !== 200) return
        this.$message.success('核销成功')
        this.hideDialog()
        this.getList()
      },
      // 分页
      handleInfoSizeChange (val) {
        this.writeOffSearchForm.pageSize = val
        this.getInfoData()
      },
      hideDialog () {
        this.dialogVisible = false
        this.$refs.multipleTable.clearSelection()
        this.$refs.form.resetFields()
        this.date = []
      },
      handleInfoCurrentChange (val) {
        this.writeOffSearchForm.pageIndex = val
        this.getInfoData()
      },
      selectable (row) {
        return [10, 20].includes(row.status)
      },
      handleSelectionChange (selection) {
        this.selection = selection.map(item => item.id)
        this.writeOffForm.invoiceInfoDtos[0].spuName = selection[0]?.oilSpuName || ''
        this.writeOffForm.invoiceInfoDtos[0].spuId = selection[0]?.oilSpu || ''
        if (!selection.length) return this.totalAmount = 0
        this.totalAmount = selection.reduce((total, item) => {
          return total + parseFloat(item.invoiceAmount.split(',').join(''))
        }, 0)
      },
      resetForm () {
        this.$refs.form.resetFields()
        this.form.pageIndex = 1
        this.getList()
      }
    },
    created () {
      this.initEnum()
      this.getList()
    }
  }
</script>
<style lang="less" scoped>
  .background {
    margin-top: 30px;
    padding: 20px;
    background-color: #fff;
  }
  .pagination {
    text-align: right;
    margin-top: 20px;
  }
</style>
